import SearchPromoBlock from '@cms/blocks/search-promo-block'
import slugify from '@sindresorhus/slugify'

interface FilteredPromoProps {
  userData: any;
  promos: any
}

const FilteredPromos = ({ userData, promos }: FilteredPromoProps) => {
  const filteredPromos = [];
  for(const userPromo of userData){
    const promoKey = slugify(userPromo.internalName);
    if( promoKey in promos ){
      for(const promoBlock of promos[promoKey].fields.blocks){
        filteredPromos.push(promoBlock.fields)
      }
    }
  }
  
  return (
    <div className="flex flex-col gap-8 mt-8">
      { filteredPromos.map((fp:any) => (
        <div key={fp.internalName} data-testid="search-promo">
          <SearchPromoBlock {...fp} />
        </div>
      ))}
    </div>
  )
}

export default FilteredPromos;